import { baseURL } from '../config/globalConfig.js';
import axios from 'axios';
let mainService = {
  // 登录
  login (params) {
    return new Promise((resolve, reject) => {
      axios.get(baseURL + `api/login/`, {params}).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },
  // 退出登录
  logout () {
    return new Promise((resolve, reject) => {
      axios.get(baseURL + `api/logout`, {}).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },
  // 校验是否登录
  checkLogin (params) {
    return new Promise((resolve, reject) => {
      axios.get(baseURL + `check/login`, {params}).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },
  // 用户信息
  user (params) {
    return new Promise((resolve, reject) => {
      axios.get(baseURL + `user`, {params}).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },
  // 检测系统是否授权
  checkAuthorize () {
    return new Promise((resolve, reject) => {
      axios.get(baseURL + `api/system/authorize`).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },
  // 获取微信分享签名
  wxShare (params) {
    return new Promise((resolve, reject) => {
      axios.post(baseURL + `api/live/weixin/share`, params).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },
  // 获取平台信息
  getPlatformInfo () {
    return new Promise((resolve, reject) => {
      axios.get(baseURL + `api/find/platform/info`).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },
  // 获取平台信息-登录访问
  getPlatformInfoLogin () {
    return new Promise((resolve, reject) => {
      axios.get(baseURL + `find/platform/info`).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },
  // 设置平台信息
  setPlatformInfo (params) {
    return new Promise((resolve, reject) => {
      axios.post(baseURL + `save/platform/info`, params).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },
  // 获取统计平台域名
  getStatisticsUrl () {
    return new Promise((resolve, reject) => {
      axios.get(baseURL + 'api/get/data/url').then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }
};
export {
  mainService
};



// WEBPACK FOOTER //
// ./src/services/liveManage.main.js